import React from 'react';

import { Button } from '@chakra-ui/react';

import { useFormControlGroup } from '../../../hooks/use-form-control-group';
import { PlaceholderProps } from '../types';

export const Placeholder = ({
  onOpen,
  selectedOptions,
  placeholder,
  disabled,
  optionTemplate,
}: PlaceholderProps) => {
  const hasSelectedOptions = Object.keys(selectedOptions).length > 0;
  const { contextData } = useFormControlGroup();

  return (
    <Button
      variant="secondary"
      textAlign="left"
      sx={{
        fontWeight: 'normal',
        _hover: {
          color: hasSelectedOptions ? 'grey.900' : 'grey.400',
          borderColor: contextData?.state === 'error' ? 'red.500' : 'blue.300',
        },
        _disabled: {
          bg: 'grey.50',
          color: 'grey.900',
          borderColor: 'grey.500',
          cursor: 'default',
        },
      }}
      justifyContent="left"
      w="100%"
      onClick={onOpen}
      paddingLeft="4"
      color={hasSelectedOptions ? 'grey.900' : 'grey.400'}
      borderColor={contextData?.state === 'error' ? 'red.500' : 'grey.400'}
      rounded="sm-md"
      isDisabled={disabled}
    >
      {hasSelectedOptions ? optionTemplate(selectedOptions) : placeholder}
    </Button>
  );
};
